import { render, staticRenderFns } from "./IndustrialPark.vue?vue&type=template&id=06b829e2&scoped=true&"
import script from "./IndustrialPark.vue?vue&type=script&lang=js&"
export * from "./IndustrialPark.vue?vue&type=script&lang=js&"
import style0 from "./IndustrialPark.vue?vue&type=style&index=0&id=06b829e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b829e2",
  null
  
)

export default component.exports